/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrialOnboardingProgressControllerCreateMutationRequest, TrialOnboardingProgressControllerCreateMutationResponse, TrialOnboardingProgressControllerCreate400, TrialOnboardingProgressControllerCreate401, TrialOnboardingProgressControllerCreate403, TrialOnboardingProgressControllerCreate409 } from "../../models/trialOnboardingProgressController/TrialOnboardingProgressControllerCreate";

function getTrialOnboardingProgressControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/trial-onboarding-progress` as const }  
  return res
}

/**
 * @summary Create trial onboarding progress
 * {@link /api/v1/trial-onboarding-progress}
 */
export async function trialOnboardingProgressControllerCreate(data?: TrialOnboardingProgressControllerCreateMutationRequest, config: Partial<RequestConfig<TrialOnboardingProgressControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TrialOnboardingProgressControllerCreateMutationResponse, ResponseErrorConfig<TrialOnboardingProgressControllerCreate400 | TrialOnboardingProgressControllerCreate401 | TrialOnboardingProgressControllerCreate403 | TrialOnboardingProgressControllerCreate409>, TrialOnboardingProgressControllerCreateMutationRequest>({ method : "POST", url : getTrialOnboardingProgressControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}